import { render, staticRenderFns } from "./rectify.vue?vue&type=template&id=215d621a&scoped=true&"
import script from "./rectify.vue?vue&type=script&lang=js&"
export * from "./rectify.vue?vue&type=script&lang=js&"
import style0 from "./rectify.vue?vue&type=style&index=0&id=215d621a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215d621a",
  null
  
)

export default component.exports